
import LocalePickerModal from '@marketplace/components/modals/ds/LocalePickerModal.vue'
import NavItem from '@marketplace/components/nav/nav-item.vue'
import CurrentLanguageMenuItem from '@marketplace/components/nav/parts/current-language-menu-item.vue'
import OcDrawer from '@marketplace/components/shared/drawer/oc-drawer.vue'
import ocDrawerMixin from '@marketplace/components/shared/drawer/ocDrawerMixin.js'
import { trackHeaderClick } from '@marketplace/helpers/segment/index.js'
import { mapGetters } from 'vuex'

export default {
    name: 'AccountDrawer',

    components: {
        OcDrawer,
        CurrentLanguageMenuItem,
        NavItem,
    },

    mixins: [ocDrawerMixin],
    props: {
        links: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            profileTitle: window.Store?.userFirstName
                ? `${this.$t('labels.hi')} ${window.Store.userFirstName}`
                : this.$t('nav.account'),
            userType: window.Store.accountType,
        }
    },

    computed: {
        ...mapGetters('global', [
            'inboxUnreadCount',
            'isAssociationRetailer',
            'userCountry',
        ]),
        ...mapGetters('ocplus', ['canSeeOcPlus']),
        drawerIsOpen() {
            return this.__currentOpenDrawer === 'account'
        },
        isInCoreCountry() {
            return ['NL', 'BE', 'DE', 'AT'].includes(
                this.userCountry.toUpperCase()
            )
        },
    },

    methods: {
        closeDrawer() {
            this.__openDrawer(false)
        },
        canBeShown(hiddenFor, path) {
            // Don't render the '/account/plus' path if the user is not in a core country
            if (path === '/account/plus' && !this.isInCoreCountry) {
                return false
            }

            if (!hiddenFor) {
                return true
            }

            if (
                hiddenFor.includes('supplier') &&
                this.$helpers.isSupplierAccount
            ) {
                return false
            }

            if (
                hiddenFor.includes('notAssociationMember') &&
                this.isAssociationRetailer
            ) {
                return false
            }

            if (hiddenFor.includes('isOCPlus') && !this.canSeeOcPlus) {
                return false
            }

            if (!hiddenFor.includes(this.userType)) {
                return true
            }

            return false
        },
        triggerLanguageCurrencyModal() {
            this.$vfm.show({
                component: LocalePickerModal,
            })
        },
        trackHeaderClick,
        handleDynamicComponentClick(methodToCall) {
            if (!methodToCall) return
            this[methodToCall]()
        },
    },
}
